import React from 'react';

import Table from './Sql/Table';

const ObjectView = (props: any) => <Table table={props.tab.get('table')} />;

export default ObjectView;
